import { logger } from '@service-initiation/shared-clients-osp-logger';

import { getDeviceTypes } from './getDeviceTypes';
import { type DeviceDetails } from './types/DeviceDetails';
import { hydrateDeviceParentRecursive } from './utils/hydrateDeviceParentRecursive';

export const getDeviceDetails = async (
  deviceTypeId: number
): Promise<DeviceDetails> => {
  try {
    const devices = await getDeviceTypes({ deviceTypeId: deviceTypeId });

    const device = devices.find((d) => d.id === deviceTypeId);

    if (!device) {
      throw new Error(`Device with id ${deviceTypeId} not found`);
    }

    return hydrateDeviceParentRecursive(device, devices);
  } catch (e) {
    const err = e as Error;
    err.message = 'Error occurred while trying to fetch device details';
    logger.error(err, {
      data: { deviceTypeId },
    });
    throw err;
  }
};
